/**
 * A Reserve with Google token captured from a booking link, plus the shop that
 * was on screen when it was captured. `shopId` holds the URL's shop segment —
 * the same value space as the `shopId` passed to checkout — so the two can be
 * compared to derive `merchant_changed`.
 */
export type RwgAttribution = {
  token: string;
  shopId?: string;
  capturedAt: number;
};

/** Google's values for "was a different merchant booked than the one presented". */
export const MERCHANT_CHANGED = 1;
export const MERCHANT_UNCHANGED = 2;

export type MerchantChanged =
  | typeof MERCHANT_CHANGED
  | typeof MERCHANT_UNCHANGED;
